import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Paper,
    Collapse,
    Box,
    IconButton,
    Typography,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import TaskDetails from "../../../../src/assests/images/Task-detail.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
//import RewardsFilterPopup from "./RewardsFilterPopup";
import RewardsFilterPopup from "../RewardsPointsBook/RewardsFilterPopup";
import PaginationComponent from "../../brands/Pagination";
import ReportAllFilter from "./ReportAllFilter";
import DropDownFilter, { Option } from "./DropDownFilter";
import Export from "../../../../src/assests/images/export.svg";
const columns: Option[] = [
    { label: "User ID", value: "user_id" },
    { label: "User Name", value: "user_name" },
    { label: "Outlet Name", value: "outlet_name" },
    { label: "Location", value: "location" },
    { label: "Member Since", value: "member_since" },
    { label: "Total Points", value: "total_points" },
    { label: "Phone Number", value: "phone" },
    { label: "Current Points", value: "current_points" },
];
// Dummy interfaces
interface Task {
    transactions: string;
    task_date: string;
    request_date: string;
    status: string;
    approval_date: string;
}

export interface RewardPointResponse {
    utm_id: number;
    account_id: number;
    fullName: string;
    member_since: string;
    outlet_name: string;
    location: string;
    points_expires_in: string;
    total_points: number;
    userId: number;
}


const mockUsers: RewardPointResponse[] = [
    {
        utm_id: 1,
        account_id: 1001,
        fullName: "John Doe",
        member_since: "2022-01-10",
        outlet_name: "Outlet A",
        location: "New York",
        points_expires_in: "30 Days",
        total_points: 1200,
        userId: 1,
    },
    {
        utm_id: 2,
        account_id: 1002,
        fullName: "Jane Smith",
        member_since: "2021-05-20",
        outlet_name: "Outlet B",
        location: "Los Angeles",
        points_expires_in: "60 Days",
        total_points: 800,
        userId: 2,
    },
];

// ✅ Dummy mock tasks
const mockTasks: Task[] = [
    {
        transactions: "TXN123",
        task_date: "2023-01-01",
        request_date: "2023-01-02",
        status: "Approved",
        approval_date: "2023-01-03",
    },
    {
        transactions: "TXN124",
        task_date: "2023-02-01",
        request_date: "2023-02-02",
        status: "Pending",
        approval_date: "-",
    },
];

const ExpandableTableRow = ({ row }: { row: RewardPointResponse }) => {
    const [open, setOpen] = useState(false);
    const [selectedCols, setSelectedCols] = useState<string[]>([]);

    return (
        <>
            <TableRow>
                <TableCell>
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                    {row.account_id}
                </TableCell>
                <TableCell>{row.fullName}</TableCell>
                <TableCell>{row.outlet_name}</TableCell>
                <TableCell>{row.location}</TableCell>
                <TableCell>{row.member_since}</TableCell>
                <TableCell>{row.total_points}</TableCell>
                <TableCell>
                    <Button
                        variant="contained"
                        size="small"
                        sx={{
                            background: "#FBF3E0",
                            color: "#CA8501",
                            borderRadius: "30px",
                            boxShadow: "none",
                        }}
                    >
                        {row.points_expires_in}
                    </Button>
                </TableCell>
                <TableCell>
                    <img src={TaskDetails} alt="Task Details" />
                </TableCell>
            </TableRow>

            {/* Expandable Row */}
            <TableRow>
                <TableCell style={{ padding: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="tasks">
                                <TableHead sx={{ background: "#EEF4FF" }}>
                                    <TableRow>
                                        <TableCell>Transactions</TableCell>
                                        <TableCell>Task Date</TableCell>
                                        <TableCell>Request Date</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Approval Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mockTasks.map((task, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{task.transactions}</TableCell>
                                            <TableCell>{task.task_date}</TableCell>
                                            <TableCell>{task.request_date}</TableCell>
                                            <TableCell>{task.status}</TableCell>
                                            <TableCell>{task.approval_date}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

const RewardsAllTable = () => {
    const [users, setUsers] = useState<RewardPointResponse[]>(mockUsers);
    const [page, setPage] = useState(1);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const popupRef = useRef<HTMLDivElement | null>(null);
    const [selectedCols, setSelectedCols] = useState<string[]>([]);
    // Pagination
    const itemsPerPage = 10;
    const totalPages = Math.ceil(users.length / itemsPerPage);
    const paginatedUsers = users.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    // Toggle filters popup
    const togglePopup = (event: React.MouseEvent) => {
        event.stopPropagation();
        setIsPopupVisible((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
                setIsPopupVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // function setSelectedCols(next: string[]): void {
    //     throw new Error("Function not implemented.");
    // }

    return (
        <Box sx={{ background: "#fff" }}>
            <Box
                sx={{
                    padding: "25px ",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{ fontSize: "16px", fontWeight: "600", marginTop: "10px" }}>
                    Total {users.length} Users
                </Typography>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "200px", marginRight: "20px" }}>
                        <DropDownFilter

                            placeholder="Select columns"
                            options={columns}
                            value={selectedCols}
                            onChange={setSelectedCols} tabKey={""}                        />

                    </Box>
                    <Button
                        variant="contained"
                        onClick={togglePopup}
                        sx={{
                            textTransform: "capitalize",
                            backgroundColor: "#fff",
                            height: "44px",
                            padding: "7px 12px",
                            borderRadius: "4px",
                            color: "#565656",
                            border: "1px solid #DEDEDE",
                            boxShadow: "none",
                            marginRight: "20px",
                            "&:hover": { backgroundColor: "#fff" },
                        }}
                        endIcon={<ExpandMoreIcon sx={{ fontSize: "30px" }} />}
                    >
                        Filters
                    </Button>
                    {isPopupVisible && (
                        <div ref={popupRef}>
                            <ReportAllFilter />
                        </div>
                    )}
                    <Button
                        variant="contained"
                        sx={{
                            textTransform: "capitalize",
                            backgroundColor: "#fff",
                            fontSize: "14px",
                            fontWeight: "500",
                            height: "40px",
                            padding: "16px",
                            borderRadius: "10px",
                            color: "#C8172F",
                            border: "1px solid #C8172F",
                            boxShadow: "none",
                            "&:hover": {},
                            "& .MuiButton-endIcon": {
                                fontSize: "30px",
                                color: "var(--Icon-Colour, #C8172F)",
                            },
                            "&:before, &:after": {
                                border: "none",
                            },
                        }}
                        startIcon={<img src={Export} alt="export"></img>}

                    >
                        Export CSV
                    </Button>
                </Box>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ background: "#EEF4FF" }}>
                        <TableRow>
                            <TableCell>User ID</TableCell>
                            <TableCell>User Name</TableCell>
                            <TableCell>Outlet Name</TableCell>
                            <TableCell>Location</TableCell>
                            <TableCell>Member Since</TableCell>
                            <TableCell>Total Points</TableCell>
                            <TableCell>Points Expiring</TableCell>
                            <TableCell>Task Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedUsers.map((row) => (
                            <ExpandableTableRow key={row.userId} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Pagination */}
            {totalPages > 1 && (
                <PaginationComponent
                    page={page}
                    limit={itemsPerPage}
                    totalPages={totalPages}
                    setPage={(newPage: React.SetStateAction<number>) => setPage(newPage)}
                />
            )}
        </Box>
    );
};

export default RewardsAllTable;
